import Immutable from 'immutable'
import Config from '../constants/config.js'
import CarrotAPI from './carrot'

import { devEnv } from '../lib/index'

const options = Config.apiOptions
const api = new CarrotAPI(options)

class Singleton {
    get() {
        return api
    }
}

let capiSingleton = new Singleton()
Object.freeze(capiSingleton)

export default capiSingleton

export class CarrotHelper {
    static setCredentials(capi, credentials) {
        if (credentials == null) {
            devEnv() && console.warn('CarrotHelper - setting empty credentials')
        }

        if (credentials instanceof Immutable.Map) {
            capi.setCredentials(credentials.toJS())
        } else {
            capi.setCredentials(credentials)
        }

        devEnv() && console.log('Setting Credentials:', capi.getCredentials())
    }
}



// WEBPACK FOOTER //
// ./src/api/carrotApi.js